import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import App from './App';
import AccessibilityWidget from './components/accessibility/AccessibilityWidget';
import './styles/index.css';

const API_URL = import.meta.env.VITE_API_URL || import.meta.env.VITE_API_BASE_URL || '/api';

function normalizeApiUrl(url) {
  if (!url) return '/api';
  const trimmed = String(url).replace(/\/+$|\s+$/g, '');
  if (trimmed.includes('/api')) return trimmed;
  return `${trimmed}/api`;
}

const apiBaseUrl = normalizeApiUrl(API_URL);
const nativeFetch = window.fetch.bind(window);

window.fetch = (input, init) => {
  if (typeof input === 'string' && /^\/api(?:\/|\?|$)/.test(input)) {
    return nativeFetch(`${apiBaseUrl}${input.slice(4)}`, init);
  }

  if (input instanceof Request) {
    const requestUrl = new URL(input.url);
    if (requestUrl.origin === window.location.origin && /^\/api(?:\/|\?|$)/.test(requestUrl.pathname)) {
      requestUrl.pathname = `${apiBaseUrl.replace(/^https?:\/\/[^/]+/i, '')}${requestUrl.pathname.slice(4)}`;
      const base = new URL(apiBaseUrl, window.location.origin);
      requestUrl.protocol = base.protocol;
      requestUrl.host = base.host;
      return nativeFetch(new Request(requestUrl.toString(), input), init);
    }
  }

  return nativeFetch(input, init);
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
        <AccessibilityWidget />
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#1e293b',
              color: '#f1f5f9',
            },
          }}
        />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
